import React from 'react';
import { shape, string, node, number } from 'prop-types';
import { getPrizeCategoryNameById, getJurisdictionNameById } from '@paddl/utils-js';
import { LogoCardWithText } from '../../../..';
import { DetailsWrapper } from '../../../Activity.styles';
export const PrizeRead = _ref => {
  let {
    data: {
      details: {
        name,
        issuer: {
          icon: issuerIcon,
          name: issuerName
        },
        description,
        categoryId,
        jurisdictionId
      }
    },
    editButton
  } = _ref;
  return /*#__PURE__*/React.createElement(DetailsWrapper, null, editButton, /*#__PURE__*/React.createElement("h1", {
    className: "headline"
  }, name), /*#__PURE__*/React.createElement(LogoCardWithText, {
    avatarUrl: issuerIcon,
    title: issuerName
  }), description ? /*#__PURE__*/React.createElement("p", null, description) : null, /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, "".concat(getPrizeCategoryNameById(categoryId), " \u2022 ").concat(getJurisdictionNameById(jurisdictionId))));
};
PrizeRead.propTypes = {
  data: shape({
    details: shape({
      name: string.isRequired,
      issuer: shape({
        icon: string,
        name: string
      }).isRequired,
      description: string,
      categoryId: number,
      jurisdictionId: number
    }).isRequired
  }).isRequired,
  editButton: node
};
PrizeRead.defaultProps = {
  editButton: undefined
};